/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../config.js";

const state = {
  currentProjectId: null,
  currentProject: null,
  projectList: [],
  isStageNavActive: false,
  currentActivePrimaryAsset: [],
  currentActiveClimateHazards: [],
  currentProjectAssetCriticalityList: [],
  currentProjectClimateCriticalityList: [],
  projectMapScenes:[
    // {
    //     code: 'BRBR',
    //     mapId: 'c48dda916176495ca5f2d90bdcf83419',
    //     sceneId: 'ebf570d1cc8f4e99b4d0579dcde7e9e9',
    //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66080 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66124&filterPaneEnabled=false&navContentPaneEnabled=false'
    // },
    // {
    //     code: 'FRBS',
    //     mapId: '276400f36bca4fec8e02c29aab0f8ab3',
    //     sceneId: '551c7c55a65643958dcc218e7c82752f',
    //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66204 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66137&filterPaneEnabled=false&navContentPaneEnabled=false'
    // },
    // {
    //     code: 'PHBD',
    //     mapId: 'c7fb440fe261456b830f7a6241d66ac3',
    //     sceneId: '014025bbfaf44d449f90a6f447e91238',
    //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66204 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66137&filterPaneEnabled=false&navContentPaneEnabled=false'
    // },
    {
        code: 'WHPW',
        mapId: 'ca861c5121c848f48f2216a0fe89944f',
        sceneId: '',
        climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67019&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'HDPS',
      mapId: 'b2ea11b00e3d41e3850440665af6e6b3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66148 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66194&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'FRPB',
      mapId: '4b784a82f6c349668591d68cb36dd17a',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66148 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66194&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'APSP-S1',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'APSP-S3',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'APSP-S4',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'APSP-S10',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'NBWS-WO49',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'NBWS-WO50',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'NBWS-WO51',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'FAST-1',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    },
    {
      code: 'FAST-5',
      mapId: '7e99d355039a432baaca96ba85f60aa3',
      sceneId: '',
      climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
    }
  ],
  projectAssessmentStakeholdersList: [],
  assessmentStagesList: []
}

function initialState() {
    return {
        currentProjectId: null,
        currentProject: null,
        projectList: [],
        isStageNavActive: false,
        currentActivePrimaryAsset: [],
        currentActiveClimateHazards: [],
        currentProjectAssetCriticalityList: [],
        currentProjectClimateCriticalityList: [],
        projectMapScenes:[
            // {
            //     code: 'BRBR',
            //     mapId: 'c48dda916176495ca5f2d90bdcf83419',
            //     sceneId: 'ebf570d1cc8f4e99b4d0579dcde7e9e9',
            //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66080 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66124&filterPaneEnabled=false'
            // },
            // {
            //     code: 'FRBS',
            //     mapId: '276400f36bca4fec8e02c29aab0f8ab3',
            //     sceneId: '551c7c55a65643958dcc218e7c82752f',
            //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67019&filterPaneEnabled=false'
            // },
            // {
            //     code: 'PHBD',
            //     mapId: 'c7fb440fe261456b830f7a6241d66ac3',
            //     sceneId: '014025bbfaf44d449f90a6f447e91238',
            //     climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66204 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66137&filterPaneEnabled=false'
            // },
            {
                code: 'WHPW',
                mapId: 'ca861c5121c848f48f2216a0fe89944f',
                sceneId: '',
                climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67019&filterPaneEnabled=false'
            },
            {
              code: 'HDPS',
              mapId: 'b2ea11b00e3d41e3850440665af6e6b3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66148 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66194&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'FRPB',
              mapId: 'b2ea11b00e3d41e3850440665af6e6b3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66148 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 66194&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'APSP-S1',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'APSP-S3',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'APSP-S4',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'APSP-S10',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'NBWS-WO49',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              mapId: '',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'NBWS-WO50',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              mapId: '',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'NBWS-WO51',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              mapId: '',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'FAST-1',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            },
            {
              code: 'FAST-5',
              mapId: '7e99d355039a432baaca96ba85f60aa3',
              sceneId: '',
              climateDashboardURL: 'https://app.powerbi.com/reportEmbed?reportId=31cf92f9-4f4e-42d9-a19e-576fd974dbc0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&$filter=Rainfall_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119 and Temp_Maximum_Daily/Bureau_x0020_of_x0020_Meteorology_x0020_station_x0020_number eq 67119&filterPaneEnabled=false&navContentPaneEnabled=false'
            }
        ],
        projectAssessmentStakeholdersList: [],
        assessmentStagesList: []
    }
}
const mutations = {
  clearProjectEntries(state) {
    state.projectList = []
  },
  setProjectEntries(state, payload) {
    state.projectList.push(payload)
  },
  setCurrentProject(state, payload) {
    state.currentProjectId = payload
    var currentProject = state.projectList.filter(obj=>{return obj.id == payload})
    state.currentProject = currentProject[0]
  },
  clearCurrentProject(state) {
    state.currentProjectId = null
    state.currentProject = null
  },
  resetStageNav(state) {
    state.isStageNavActive = false
  },
  setStageNav(state, payload) {
    state.isStageNavActive = payload
  },
  clearCurrentProjectPrimaryAsset(state, payload){
    state.currentActivePrimaryAsset = []
  },
  setCurrentProjectPrimaryAsset(state, payload){
    let primaryAssetType = {}
    primaryAssetType.label = payload.name
    primaryAssetType.id = payload.id
    primaryAssetType.code = payload.code
    primaryAssetType.designLife = payload.design_life
    primaryAssetType.isActive = payload.is_active==1?true:false
    state.currentActivePrimaryAsset.push(primaryAssetType)
  },
  clearCurrentClimateHazards(state, payload){
    state.currentActiveClimateHazards = []
  },
  setCurrentClimateHazards(state, payload){
    state.currentActiveClimateHazards.push(payload.code)
  },
  clearCurrentProjectAssetCriticalityList(state) {
    state.currentProjectAssetCriticalityList = []
  },
  setCurrentProjectAssetCriticalityList(state, payload) {
    payload.forEach(item=>{
        state.currentProjectAssetCriticalityList.push(item)
    })
  },
  clearCurrentProjectClimateCriticalityList(state) {
    state.currentProjectClimateCriticalityList = []
  },
  setCurrentProjectClimateCriticalityList(state, payload) {
    payload.forEach(item=>{
        state.currentProjectClimateCriticalityList.push(item)
    })
  },
  clearProjectAssessmentStakeholders(state) {
    state.projectAssessmentStakeholdersList = []
  },
  setProjectAssessmentStakeholders(state, payload) {
    state.projectAssessmentStakeholdersList.push(payload)
  },
  clearAssessmentStages(state) {
    state.assessmentStagesList = []
  },
  setAssessmentStages(state, payload) {
    state.assessmentStagesList.push(payload)
  },
}

const actions = {
  fetchProjects({commit, dispatch}) {
    return new Promise(function(resolve, reject){
        try {
            let url = baseApiUrl + "projects"
            axios.get(url).then(result=>{
                commit("clearProjectEntries")
                result.data.forEach(item=>{
                    commit("setProjectEntries", item)
                })
                resolve(true)
            })
        } catch (error) {
            reject(error)
        }
    })
  },
  fetchProjectActivePrimaryAssets({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + "projectActivePrimaryAssets"
        let data = {
          projectId: state.currentProjectId
        }
        let config  = {
            responseType: 'json'
        }
        axios.post(url, data, config).then(result=>{
            commit('clearCurrentProjectPrimaryAsset')
            result.data.activePrimaryAssets.forEach(item=>{
                commit('setCurrentProjectPrimaryAsset', item)
              })
              
              resolve()
          })
      })
  },
  fetchProjectActiveClimateHazards({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + "projectClimateHazards"
        let data = {
            params: {

                projectId: state.currentProjectId
            }
        }
        let config  = {
            responseType: 'json'
        }
        axios.get(url, data, config).then(result=>{
            commit('clearCurrentClimateHazards')
            result.data.projectClimateHazards.forEach(item=>{
                commit('setCurrentClimateHazards', item)
              })
              resolve()
          })
      })
  },
  fetchProjectAssetCriticalityList({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + 'projectAssetCriticalityChecklist'
        let data = {
            params: {
                projectId: payload
            }
        }
        let config = {
            responseType: 'json'
        }
        axios.get(url, data, config). then(result=>{
            commit('clearCurrentProjectAssetCriticalityList')
            commit('setCurrentProjectAssetCriticalityList', result.data.assetCriticalityList)
            resolve()  
        })
    })
  },
  fetchProjectClimateCriticalityList({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + 'projectClimateCriticalityChecklist'
        let data = {
            params: {
                projectId: payload
            }
        }
        let config = {
            responseType: 'json'
        }
        axios.get(url, data, config). then(result=>{
            commit('clearCurrentProjectClimateCriticalityList')
            commit('setCurrentProjectClimateCriticalityList', result.data.climateCriticalityList)
            resolve()  
        })
    })
  },
  updateActiveClimateHazards({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + "updateActiveClimateHazards"
        let data = {
            activeCodes: payload.activeCodes,
            projectId: payload.projectId
        }
        let config  = {
            responseType: 'json'
        }
        axios.post(url, data, config).then(result=>{
            dispatch('fetchProjectActiveClimateHazards').then(()=>{
                resolve()
            })
        })
    })
  },
  updateActivePrimaryAssetTypes({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + "updateActivePrimaryAssetTypes"
        let data = {
            projectId: state.currentProjectId,
            primaryAssetData: payload
        }
        let config  = {
            responseType: 'json'
        }
        axios.post(url, data, config).then(result=>{
            dispatch('fetchProjectActivePrimaryAssets').then(()=>{
                    resolve();
            })
        })
    })
  },
  fetchAssessmentStages({commit, dispatch}) {
    return new Promise(function(resolve, reject){
        try {
            let url = baseApiUrl + "assessmentStages"
            axios.get(url).then(result=>{
                commit("clearAssessmentStages")
                result.data.forEach(item=>{
                    commit("setAssessmentStages", item)
                })
                resolve(true)
            })
        } catch (error) {
            reject(error)
        }
    })
  },
  fetchProjectAssessmentStakeholders({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        try {
            let url = baseApiUrl + "projectAssessmentStakeholders"
            let data = {
                params: {
                    projectId: payload
                }
            }
            let config = {
                responseType: 'json'
            }
            axios.get(url, data, config).then(result=>{
                commit("clearProjectAssessmentStakeholders")
                result.data.forEach(item=>{
                    commit("setProjectAssessmentStakeholders", item)
                })
                resolve(true)
            })
        } catch (error) {
            reject(error)
        }
    })
  },
  updateProjectAssessmentStakeholders({state, commit, dispatch}, payload) {
    return new Promise(function(resolve, reject){
        let url = baseApiUrl + "projectAssessmentStakeholders"
        
        let config  = {
            responseType: 'json'
        }

        payload.forEach((item,index) => {
          let data = {
            projectId: item.projectId,
            code: item.code,
            attendees: item.attendees
          }
          axios.put(url, data, config).then(result=>{
            resolve();
          })
        })
        
        
    })
  },
}

const getters = {}



export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
